'use client';

import { forwardRef, useContext } from 'react';

import { css, cx } from '@/styled-system/css';

import { Text } from '../text';
import { PaginationRootContext } from './context/pagination-root.context';
import { paginationReadoutRecipe } from './styles/pagination-readout.styles';
import type { PaginationReadoutPropsInterface } from './types/pagination-readout.types';

/**
 * The textual display alternative to page buttons
 * @since 10.0.0
 */
export const PaginationReadout = forwardRef<HTMLLIElement, PaginationReadoutPropsInterface>(
  (props: PaginationReadoutPropsInterface, forwardedRef) => {
    const { children, className, css: cssProp, ...rest } = props;
    const {
      currentPageIndex = 0,
      totalPages,
      showNumberButtons,
    } = useContext(PaginationRootContext);

    const styles = css(cssProp, paginationReadoutRecipe.raw({ ...showNumberButtons }));

    return (
      <li
        aria-current="page"
        className={cx('c11n', styles, className)}
        data-c11n-component="Pagination.Readout"
        data-c11n-version={__C11N_VERSION__}
        ref={forwardedRef}
        {...rest}
      >
        <Text>{children ?? `Page ${currentPageIndex + 1} of ${totalPages}`}</Text>
      </li>
    );
  },
);

PaginationReadout.displayName = 'Pagination.Readout';
